"use client";
import {
  image_default
} from "./chunk-BHGNW4BO.mjs";
import {
  useImage
} from "./chunk-VKNWGH3N.mjs";
export {
  image_default as Image,
  useImage
};
